import type { CSSProperties } from "react";

// `object-position` only pans within the natural over-cover area, so on the axis
// where the image already fills the container it has no effect even when the
// image is zoomed. Adding `translate(offsetX * (scale - 1) / scale, ...)` after
// `scale` contributes exactly the scale-induced overflow, so panning works in
// both axes at any scale and matches the image edge at offset ±50.
export function imagePositionStyle(
  scale: number,
  offsetX: number,
  offsetY: number,
): CSSProperties {
  if (scale === 1 && offsetX === 0 && offsetY === 0) {
    return { objectPosition: "50% 50%" };
  }
  const style: CSSProperties = {
    objectPosition: `${50 - offsetX}% ${50 - offsetY}%`,
  };
  if (scale !== 1) {
    const tx = (offsetX * (scale - 1)) / scale;
    const ty = (offsetY * (scale - 1)) / scale;
    style.transform = `scale(${scale}) translate(${tx}%, ${ty}%)`;
  }
  return style;
}
